import styled from 'styled-components';
import { deviceBreakpoints } from '../../../../../../hooks/useDeviceQuery.hook';
import { colorsV2 } from '../../../../../colors-v2';

export const TocContentLayout = styled.nav`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
  padding-inline-start: 0;

  @media screen and ${deviceBreakpoints.fromDesktop} {
    gap: 16px;
  }

  li {
    &.active,
    &.selected {
      > a {
        color: ${colorsV2.primary100};
      }
    }

    a {
      color: ${colorsV2.black80};

      :hover {
        color: ${colorsV2.primary100};
      }
    }
  }
`;
